import { useEffect, useRef } from 'react';

export default function usePrevious(value: string): string {
  const ref = useRef('');

  useEffect(() => {
    ref.current = value;
  });
  if (!ref.current) return '';

  return ref.current;
}
